<template>
  <v-dialog v-model="dialog" max-width="700px" persistent>
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4" class="py-0">
              <v-text-field
                v-model="editedItem.key"
                label="Key"
                filled
                v-validate="{
                  required: true
                }"
                name="key"
                :error-messages="errors.collect('key')"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" class="py-0">
              <v-select
                v-model="editedItem.category"
                :items="categories"
                label="category"
                filled
                v-validate="{
                  required: true
                }"
                name="category"
                :error-messages="errors.collect('category')"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" class="py-0">
              <v-select
                v-model="editedItem.type"
                :items="['string', 'number']"
                label="Type"
                filled
                v-validate="{
                  required: true
                }"
                name="type"
                :error-messages="errors.collect('type')"
              />
            </v-col>
            <v-col cols="12" class="py-0" v-for="platform in platforms" :key="platform.id">
              <v-card class="rounded-lg mb-2" outlined>
                <v-card-title>
                  {{ platform.name }}
                </v-card-title>
                <v-card-text>
                  <div
                    v-for="(row, index) in editedItem.platforms[platform.name]"
                    :key="index"
                    class="d-flex flex-column mb-4"
                  >
                    <div class="d-flex mb-4">
                      <v-text-field
                        v-model="editedItem.platforms[platform.name][index].min"
                        label="min"
                        filled
                        type="number"
                        v-validate="{
                          required: true
                        }"
                        hide-details="auto"
                        :name="'min ' + index"
                        :error-messages="errors.collect('min ' + index)"
                      />
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            class="mx-2"
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ mdiArrowLeftRightBold }}
                          </v-icon>
                        </template>
                        <span>Between</span>
                      </v-tooltip>
                      <v-text-field
                        v-model="editedItem.platforms[platform.name][index].max"
                        label="max"
                        filled
                        type="number"
                        v-validate="{
                          required: true
                        }"
                        hide-details="auto"
                        :name="'max ' + index"
                        :error-messages="errors.collect('max ' + index)"
                      />
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="ml-2"
                            icon
                            color="red"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="editedItem.platforms[platform.name].length > 1 ? editedItem.platforms[platform.name].splice(index, 1) : null"
                          >
                            <v-icon>
                              {{ mdiDelete }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Remove row</span>
                      </v-tooltip>
                    </div>
                    <div class="d-flex justify-center">
                      <v-color-picker
                        v-model="editedItem.platforms[platform.name][index].color"
                        class="elevation-0"
                        hide-mode-switch
                        hide-inputs
                      />
                    </div>
                  </div>
                  <v-btn
                    color="green"
                    fab
                    dark
                    x-small
                    absolute
                    bottom
                    right
                    @click="editedItem.platforms[platform.name].push({ min: 0, max: 0, color: '#FFFFFF' })"
                  >
                    <v-icon>
                      {{ mdiPlus }}
                    </v-icon>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiArrowLeftRightBold, mdiDelete, mdiPlus } from "@mdi/js"
export default {
  props: {
    item: {
      type: Object,
      default: () => null
    },
    open: {
      type: Boolean,
      default: false
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  data () {
    const platforms = this.$store.state.platforms.reduce((acc, pl) =>
      ({ ...acc, [pl.name]: [{ min: 0, max: 0, color: '#FFFFFF' }] }), {}
    )
    return {
      mdiDelete,
      mdiPlus,
      mdiArrowLeftRightBold,
      dialog: false,
      editedItem: {
        key: null,
        category: null,
        type: 'string',
        platforms
      },
      defaultItem: {
        key: null,
        category: null,
        type: 'string',
        platforms
      },
    }
  },
  watch: {
    open (val) {
      this.dialog = val;
    },
    item (val) {
      if (val) {
        this.editedItem =  { ...this.defaultItem, ...val, platforms: { ...this.editedItem.platforms, ...val.platforms } }
      } else {
        this.editedItem =  { ...this.defaultItem }
      }
    },
    platforms (val) {
      const platforms = val.reduce((acc, pl) =>
        ({ ...acc, [pl.name]: [{ min: 0, max: 0, color: '#FFFFFF' }] }), {}
      )

      this.$set(this.defaultItem, 'platforms', platforms)
      this.$set(this.editedItem, 'platforms', platforms)
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Value' : 'Edit Value';
    },
    platforms () {
      return this.$store.state.platforms;
    }
  },
  methods: {
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.$emit('update', null)
      }, 300)
    },
    save () {
      this.$validator.validateAll().then(async res => {
        if (res) {
          try {
            if (this.editedItem.id) {
              const { data } = await this.$axios.put(this.$store.getters.projectPath + '/configs/runtime/' + this.editedItem.id, this.editedItem);
              this.$emit('update', data);
            } else {
              const { data } = await this.$axios.post(this.$store.getters.projectPath + '/configs/runtime', this.editedItem);
              this.$emit('create', data);
            }
          } catch(err) {
            console.log(err.message);
          }
          this.close();
        }
      })
    },
  }
}
</script>